// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awarded-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;
}

.awarded-modal-content {
    height: 3px;
    width: 50%;
    overflow: hidden;
    background-color: var(--color-contrast-dark-yellow);
    padding: 0 32px;
    border-radius: 18px;
    color: var(--color-contrast-dark-gray);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    transition: height ease-in 0.4s, padding ease-in 0.5s;
}

.awarded-modal-content.active {
    height: 250px;
    padding: 32px;
}

.awarded-modal-content span {
    opacity: 0;
    transition: opacity ease-in 0.5s;
}

.awarded-modal-content.active span {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,mDAAmD;IACnD,eAAe;IACf,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd","sourcesContent":[".awarded-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999999;\n}\n\n.awarded-modal-content {\n    height: 3px;\n    width: 50%;\n    overflow: hidden;\n    background-color: var(--color-contrast-dark-yellow);\n    padding: 0 32px;\n    border-radius: 18px;\n    color: var(--color-contrast-dark-gray);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    transition: height ease-in 0.4s, padding ease-in 0.5s;\n}\n\n.awarded-modal-content.active {\n    height: 250px;\n    padding: 32px;\n}\n\n.awarded-modal-content span {\n    opacity: 0;\n    transition: opacity ease-in 0.5s;\n}\n\n.awarded-modal-content.active span {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
